<template>
  <div class="space-between-y">
    <div class="container-left space-between-x">
      <input-item label="VIP类型">
        <el-select clearable v-model="form.miuAuthType" placeholder="请选择">
          <el-option value="parent" label="家长"></el-option>
          <el-option value="teacher" label="教师"></el-option>
        </el-select>
      </input-item>
      <input-item label="关键字">
        <el-input clearable v-model="form.keyword" placeholder="请输入关键字"></el-input>
      </input-item>
      <input-item>
        <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
      </input-item>
    </div>

    <el-table :data="list" stripe border>
      <el-table-column label="#" type="index"></el-table-column>
      <el-table-column label="用户" prop="nickname">
        <template slot-scope="scope">
          <div class="user">
            <cloud-img :url="scope.row.avatar" :img-height="30" :img-width="30" :border-radius="4"></cloud-img>
            <div class="name">{{ scope.row.nickname }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="ID" prop="id"></el-table-column>
      <el-table-column label="VIP类型" prop="type"></el-table-column>
      <el-table-column label="开通时间" prop="startTime"></el-table-column>
      <el-table-column label="结束时间" prop="endTime"></el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="showDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-model="page" @updated="getData"></pagination>

  </div>
</template>

<script>
import {vip} from "@/api/miu/vip";
import Pagination from "@/components/base/layout/Pagination.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import InputItem from "@/components/base/layout/InputItem.vue";

export default {
  name: 'MiuVipAuth',
  components: {InputItem, CloudImg, Pagination},

  data() {
    return {
      list: [],

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      form: {
        miuAuthType: null,
        keyword: null,
      },
    };
  },

  created() {
    this.getData();
  },

  methods: {
    showDetail(user) {
      this.$alert(user);
    },
    getData() {
      vip.auth.list(this.form.keyword, this.form.miuAuthType, this.page.current, this.page.size).then(res => {
        let page = res.data;
        this.list = page?.list;
        this.page.total = page?.total;
      })
    },
  },

}
</script>

<style scoped>

.user {
  display: flex;
  gap: 6px;
}
</style>
